import {CBARProcessNode} from "./CBARProcessNode";
import {CBARFrame} from "../CBARFrame";
import {CBARPipeline} from "./CBARPipeline";
import * as gm from "gammacv";
import {
    CBAREvent,
    CBAREventType, CBARMouseEvent,
} from "../../CBARTypes";
import * as THREE from "three";
import {
    RenderOptions
} from "../../components";
import {Vector3} from "three/src/math/Vector3";
import {CBARDynamicWall} from "./CBARDynamicWall";
import {CBAR3DObjectTrackerNode} from "./CBAR3DObjectTrackerNode";

// todo: turn into vec3 prototype for description or toString instead
const vec3String = (vector:Vector3) => {
    return `(${vector.x.toFixed(2)}, ${vector.y.toFixed(2)}, ${vector.z.toFixed(2)})`;
}

export class CBARSurfaceSpawnerNode extends CBARProcessNode {

    constructor(context:CBARPipeline) {
        super(context)
    }

    public walls:CBARDynamicWall[] = [];

    private _raycaster = new THREE.Raycaster();

    update(frame:CBARFrame, renderOptions:RenderOptions):void {

        this.walls.forEach(wall=>{
            wall.update(frame);
            wall.render(renderOptions);
        });
    }

    destroy() {

    }

    handleEvent(event: CBAREvent) {

        if (event.type === CBAREventType.TouchUp && event instanceof CBARMouseEvent) {
            const forward = this.pipeline.context.scene?.unproject();
            const mouseEvent = event as CBARMouseEvent;

            if (!forward || !mouseEvent.screenPoint) return;

            const seedPoint = {x:mouseEvent.point.x * this.pipeline.inputSize.width, y:mouseEvent.point.y * this.pipeline.inputSize.height};

            const wallSize ={width:30.0, height:30.0};
            const phoneElevation = 2.0;

            let pos = new THREE.Vector3();
            const distanceToWall = 4.0; //todo: calculate via various triangulation/depth nnet methods
            pos.copy(this.pipeline.context.gl.camera.position).add(forward.multiplyScalar(distanceToWall));

            let wall:CBARDynamicWall|undefined = undefined;
            const intersections = this._raycaster.intersectObjects(this.walls.map(wall=>wall.renderObject));
            if (intersections.length) {
                wall = this.walls.find(w=>w.renderObject==intersections[0].object);
            }

            if (wall) {
                wall.seedPoint = seedPoint;
            } else {
                wall = new CBARDynamicWall(this.pipeline, seedPoint, wallSize.width, wallSize.height);
                this.walls.push(wall);
                wall.addToScene();
            }

            wall.renderObject.position.set(pos.x, -phoneElevation, pos.z);
            wall.renderObject.lookAt(this.pipeline.context.gl.camera.position);
        }
    }

    debug(canvas:HTMLCanvasElement):void {

        this.walls.forEach(wall=>{

            if (!wall.material) return;

            const current = wall.seedPoint;
            const position = [current.x, current.y];

            gm.canvasDrawCircle(canvas, position, 5,  'rgba(255, 120, 0, 1)');
        });
    }

    public refresh() {
        this.walls.forEach(wall=>{
            wall.refresh();
        })
    }
}